export enum SignType {
  One2One,
  Batch,
  Dynamic
}
